export enum TIME_SETTINGS_KEYS {
  TimeZone = "timeZone",
  DateFormat = "dateFormat"
}

export enum EMAIL_NOTIFICATION_FIELDS {
  CreditsAddedAlert = "creditsAddedAlert",
  LowCreditsAlert = "lowCreditsAlert"
}
